import React, {createContext, useContext, useState, useCallback} from 'react';
import {isEqual, isFunction} from 'lodash';
import {initialFilter} from './UserDetailsUIHelpers';
import {useFormik, FormikProvider} from 'formik';
import moment from 'moment/moment';
import {shallowEqual, useSelector} from 'react-redux';

const UserDetailsUIContext = createContext();

export function useUserDetailsUIContext() {
  return useContext(UserDetailsUIContext);
}

export function UserDetailsUIProvider({children}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  const userDataHistory = useSelector((state) => state.userDetails.userDataHistory, shallowEqual);

  const historyOptions = userDataHistory
    ? userDataHistory.history
      .map(item => {
        if (item.createdAt) {
          const formattedDate = moment(item.createdAt).format('DD-MM-YYYY hh:mm:ss');
          return {label: formattedDate, value: item.createdAt};
        } else return null;
      })
      .filter(Boolean)
      .reverse()
    : [];

  const formik = useFormik({
    initialValues: {historyPoint: null},
    onSubmit: () => {
    },
    enableReinitialize: true
  });

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    historyPoint: formik.values.historyPoint,
    formik,
    historyOptions
  };

  return (
    <UserDetailsUIContext.Provider value={value}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </UserDetailsUIContext.Provider>
  );
}
